import {Component, OnInit, ViewChild} from '@angular/core';
import {NgxModalDraggableDirective} from '../../../../../directives/draggable.directive';
import {SenderService} from '../../../../../services/sender.service';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-ban-accounts',
  templateUrl: './ban-accounts.component.html',
  styleUrls: ['./ban-accounts.component.scss']
})
export class BanAccountsComponent implements OnInit {

  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    public senderService: SenderService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }
}
